import { OffersFilters } from './types';

export const SYSTEM_FEE_PERCENT = 5;

export const getTableColumns = (t: (key: string) => string) => [
  { name: t('partner.revshare.offers.table.owner'), key: 'owner', width: 410 },
  { name: t('partner.revshare.offers.table.offerDetails'), key: 'offerDetails' },
  { name: t('partner.revshare.offers.table.statistics'), key: 'statistics' },
  { name: t('partner.revshare.offers.table.actions'), key: 'actions' },
];

export const DEFAULT_FILTERS: OffersFilters = {
  type: '',
  owner: '',
  commission: '',
  model: '',
  sortBy: '',
  sortDirection: 'asc',
  source: '',
  price: '',
  topCreators: '',
  offerCommission: '',
  guaranteed: false,
  // arpu: '',
  allowedSource: '',
  excludedSource: '',
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

// Sort options matching backend RefShareOffersSort enum and Figma design
export const getSortingOptions = (t: (key: string) => string) => [
  {
    key: 'offer.commission',
    label: t('partner.revshare.offers.filters.sortCommission') || 'Комиссия',
  },
  {
    key: '-offer.commission',
    label: t('partner.revshare.offers.filters.sortCommission') || 'Комиссия',
  },
  {
    key: 'of_data.subscribers',
    label: t('partner.revshare.offers.filters.sortSubscribers') || 'Подписчики',
  },
  {
    key: '-of_data.subscribers',
    label: t('partner.revshare.offers.filters.sortSubscribers') || 'Подписчики',
  },
  { key: 'of_data.favorited', label: t('partner.revshare.offers.filters.sortLikes') || 'Лайки' },
  { key: '-of_data.favorited', label: t('partner.revshare.offers.filters.sortLikes') || 'Лайки' },
  { key: 'of_data.overall_popularity_percent', label: t('partner.revshare.offers.filters.sortTopCreators') || 'Топ создателей контента' },
  { key: '-of_data.overall_popularity_percent', label: t('partner.revshare.offers.filters.sortTopCreators') || 'Топ создателей контента' },
  { key: 'ref_share_transactions_per_subscriber', label: t('partner.revshare.offers.filters.sortArpu') || 'ARPU' },
  { key: '-ref_share_transactions_per_subscriber', label: t('partner.revshare.offers.filters.sortArpu') || 'ARPU' },
];

export const getOwnerOptions = (
  t: (key: string) => string,
  counts?: { creator: number; agency: number }
) => [
  {
    key: 'creator',
    label: counts
      ? `${t('global.auth.userTypes.creator') || 'Креатор'} (${counts.creator})`
      : t('global.auth.userTypes.creator') || 'Креатор',
  },
  {
    key: 'agency',
    label: counts
      ? `${t('global.auth.userTypes.agency') || 'Агентство'} (${counts.agency})`
      : t('global.auth.userTypes.agency') || 'Агентство',
  },
];

export const getTypeOptions = (t: (key: string) => string) => [
  { key: 'free', label: t('partner.revshare.offers.filters.free') || 'Бесплатный' },
  {
    key: 'free trial',
    label: t('partner.revshare.offers.filters.freeTrial') || 'Бесплатный пробный период',
  },
];

export const getCommissionOptions = (t: (key: string) => string) => [
  { key: '0-20', label: '0-20%' },
  { key: '20-30', label: '20-30%' },
  { key: '30-40', label: '30-40%' },
  { key: '40+', label: '40%+' },
];

// Source options for filtering
export const getSourceOptions = (t: (key: string) => string) => [
  { key: 'reddit', label: 'Reddit' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'tiktok', label: 'TikTok' },
  { key: 'twitter', label: 'Twitter' },
  { key: 'telegram', label: 'Telegram' },
  { key: 'google', label: 'Google' },
  { key: 'youtube', label: 'YouTube' },
  { key: 'another', label: t('partner.revshare.offers.filters.otherSource') || 'Другое' },
];
